<template>
  <iframe
    class="support-iframe"
    src="https://config-cdn.qiandaoapp.com/edgy/edgy_support.html"
  />
</template>

<style scoped>
.support-iframe {
  width: 100%;
  height: 100vh;
  border: none;
}
</style>
